import { useEffect, useState } from "react";
import Sidebar from "components/Common/SideBar/SideBar";
import { useLocation } from "react-router-dom";
import classes from "./BIReport.module.css";
import Default from "components/Common/Default/Default";
import ReportHeader from "components/Common/Header/Header";
import Grid from "@mui/material/Grid";
import SummaryAnalysis from "components/BiReportDisplay/SummaryAnalysis";
import LogInsights from "components/LogInsights/LogInsights";

const BIReportLayout = () => {
  const location = useLocation();

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    if (path === "/bireport") setIndex(() => 0);
    if (path === "/bireport/summaryanalysis") setIndex(() => 1);
    if (path === "/bireport/loginsights") setIndex(() => 2);
  }, [location.pathname]);

  return (
    <Grid container spacing={2} className={classes.reportBody}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={index} type="biReport" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        <ReportHeader
          title="ASTT Report Summary"
          logoURL="/biReport"
          version="new"
        />
        <div className={classes.content}>
          {index === 0 && <Default />}
          {index === 1 && <SummaryAnalysis />}
          {index === 2 && <LogInsights />}
        </div>
      </Grid>
    </Grid>
  );
};

export default BIReportLayout;
